import { lazier } from '@modules/shared/components';

export const SettingsPage = lazier(() => import('./SettingsPage'));
